<template>
  <Bar :id="id" :data="data" :options="mergedOptions" />
</template>
<script setup lang="ts">
  import {
    BarElement,
    CategoryScale,
    Chart as ChartJS,
    Legend,
    LinearScale,
    Title,
    Tooltip,
  } from 'chart.js';
  import { computed } from 'vue';
  import { Bar } from 'vue-chartjs';
  import type { ChartData, ChartOptions } from 'chart.js';
  import ChartDataLabels from 'chartjs-plugin-datalabels';

  ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    ChartDataLabels,
  );

  const props = defineProps({
    data: {
      type: Object as () => ChartData<'bar'>,
      required: true,
    },
    options: {
      type: Object as () => ChartOptions<'bar'>,
      required: true,
    },
    id: {
      type: String,
      required: true,
    },
  });

  const mergedOptions = computed<ChartOptions<'bar'>>(() => ({
    ...props.options,
    plugins: {
      ...props.options.plugins,
      datalabels: {
        ...(props.options.plugins?.datalabels as Record<string, unknown>),
      },
    },
  }));
</script>
